export const theme = {
  colors: {
    primary: "#7E57C2", // Purple
    primaryDark: "#5E35B1", // Dark purple
    secondary: "#D1C4E9", // Light purple
    background: "#F3E5F5", // Very light purple
    text: "#37474F", // Dark Gray
    white: "#FFFFFF",
    gray: "#9E9E9E",
  },
  spacing: {
    xs: "0.5rem",
    sm: "1rem",
    md: "1.5rem",
    lg: "2rem",
    xl: "3rem",
  },
  borderRadius: {
    sm: "8px",
    md: "12px",
    lg: "20px",
    circle: "50%",
  },
  shadows: {
    small: "0 2px 8px rgba(126, 87, 194, 0.1)",
    medium: "0 4px 20px rgba(126, 87, 194, 0.15)",
    large: "0 10px 40px rgba(126, 87, 194, 0.2)",
  },
};
